import dayjs from 'dayjs';
import type { LotteryCampaign, LotteryCampaignStats, LotteryFulfillmentStatus } from '../../types/lottery';
import type { CampaignFormValues } from './detailTypes';

export const fulfillmentLabels: Record<LotteryFulfillmentStatus, string> = {
  none: '无需兑奖',
  pending: '待兑奖',
  fulfilled: '已兑奖',
};

export const fulfillmentColors: Record<LotteryFulfillmentStatus, string> = {
  none: 'default',
  pending: 'orange',
  fulfilled: 'green',
};

const emptyStats: LotteryCampaignStats = {
  drawCount: 0,
  winningCount: 0,
  pendingFulfillmentCount: 0,
  prizeCount: 0,
  activePrizeCount: 0,
  soldOutPrizeCount: 0,
};

export const formatDateTime = (value?: string | null) => {
  if (!value) return '-';
  return dayjs(value).format('YYYY-MM-DD HH:mm');
};

export const formatCampaignTime = (campaign?: LotteryCampaign | null) => {
  if (!campaign) return '-';
  if (!campaign.startAt && !campaign.endAt) return '长期有效';
  return `${formatDateTime(campaign.startAt)} 至 ${formatDateTime(campaign.endAt)}`;
};

export const getStats = (campaign?: LotteryCampaign | null) => campaign?.stats || emptyStats;

export const getRuntimeStatus = (campaign: LotteryCampaign) => {
  const now = Date.now();
  if (!campaign.isActive) return { label: '已停用', color: 'red' };
  if (campaign.startAt && dayjs(campaign.startAt).valueOf() > now) return { label: '未开始', color: 'blue' };
  if (campaign.endAt && dayjs(campaign.endAt).valueOf() < now) return { label: '已结束', color: 'default' };
  return { label: '进行中', color: 'green' };
};

export const toCampaignFormValues = (campaign: LotteryCampaign): CampaignFormValues => ({
  name: campaign.name,
  description: campaign.description || '',
  isActive: campaign.isActive,
  isPrimary: campaign.isPrimary,
  isStandalone: campaign.isStandalone,
  dateRange: campaign.startAt && campaign.endAt
    ? [dayjs(campaign.startAt), dayjs(campaign.endAt)]
    : undefined,
  rules: campaign.rules || '',
});

export const toCampaignPayload = (values: CampaignFormValues) => ({
  name: values.name,
  description: values.description || null,
  isActive: values.isActive ?? true,
  isPrimary: values.isPrimary ?? false,
  isStandalone: values.isStandalone ?? false,
  startAt: values.dateRange?.[0]?.toISOString() || null,
  endAt: values.dateRange?.[1]?.toISOString() || null,
  rules: values.rules || null,
});
